import React from "react";
import { Link } from 'react-router-dom';
import linkedin from '../Assets/icons8-linkedin.svg'
import facebook from '../Assets/icons8-facebook.svg'
import logoBranco from '../Assets/White-SOC-Footer.png'
import youtube from '../Assets/icon-youtube.svg'
import twitter from '../Assets/freeicons-twitter.svg'
import { useTranslation } from 'react-i18next'
const Footer = () => {

    const { t, i18n } = useTranslation();

    const currentLanguage = i18n.language;

    let linkHref;

    if (currentLanguage.toUpperCase() === 'EN') {
        linkHref = "/eng"; 
       
    } else if (currentLanguage.toUpperCase() === 'PT') {
        linkHref = "/";
    } else {
        linkHref = "/";
    }
    
    return (
        <div className="main">
            <footer className="bg-footer">
            <hr class="opacity-md my-0"></hr>
            <div className="container space-footer">
                <div class="row mx-gutters-2">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 ">
                            <h6 class="top-item-footer mb-2">{t('TELEFONE')}</h6>
                            <p class="text-white mb-0"> <Link className="sublinha-text text-white" to="tel:+351225323740">+351 225 323 740</Link> </p>
                            </div>
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 mtb-1 email-mt">
                            <h6  class="top-item-footer mb-2">{t('E-MAIL')}</h6>
                            <p class="text-white mb-0">soc@visionware.pt</p>
                            </div>

                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3  mtb-1 mtbt-1"> 
                                <h6  class="top-item-footer font-weight-normal mb-2 legal-mt">{t('LEGAL')}</h6>
                                <Link class="list-group-item-action text-white sublinha-text" target="_blank" to="/Privacidade">{t('Aviso de Privacidade')}</Link>
                            </div>
                            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 mt-3 mtb-1 mtbt-ond texto-right-rede">
                               
                                <ul class="list-inline mb-0">
                                    
                                    <li class="list-inline-item">
                                        <span class="mb-0 list-group-item-action text-white" >
                                        {t('Onde estamos')}
                                        </span>
                                    </li>
                                    <li class="list-inline-item mt-1 mr-01">
                                        <Link  target="_blank" to="https://www.facebook.com/visionwaresi"><img src={linkedin} alt="Imagem" className="img-fluid mr-2 iconss"/></Link>
                                    </li>
                                    <li class="list-inline-item mr-02">
                                        <Link  target="_blank" to="https://www.linkedin.com/company/visionwaresi/"><img src={facebook} alt="Imagem" className="img-fluid mr-2 iconss"/></Link>
                                    </li>
                                    <li class="list-inline-item mr-03">
                                        <Link  target="_blank" to="https://twitter.com/visionwaresi"><img src={twitter} alt="Imagem" className="img-fluid mr-2 iconss"/></Link>
                                    </li>
                                    <li class="list-inline-item">
                                        <Link  target="_blank" to="https://www.youtube.com/@visionwaresistemasdeinformacao"><img src={youtube} alt="Imagem" className="img-fluid iconss"/></Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                
            </div>
            <hr class="opacity-md my-0"></hr>
            <div className="container space-footer">
                 <div className="row">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-6 col-xl-7">
                        <Link class="navbar-brand u-header__navbar-brand u-header__navbar-brand-center u-header__navbar-brand-on-scroll" to={linkHref} aria-label="Front">
                            <img src={logoBranco} alt="Imagem" className="img-fluid logo-footer"/>
                        </Link>
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5 txt-line-right">
                        <p className="text-white font-size-1 mt-mbb mt-footer">Copyright® {new Date().getFullYear()} {t('VisionWare Todos os direitos reservados')}</p>
                    </div>
                 </div>
                
            </div>
        </footer>
        </div>
    )
}

export default Footer